import { api, auth } from '@/f1/service';
import Language from './language';
import { VclFacebook } from 'vue-content-loading';
import config from '../../../config'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: { Language, VclFacebook },
  computed:{
    i18n_data() { return _i18n_data; },
    web_server_img() {
      return { blank: false, width: '100%', class: 'm-4' }
    },
    redir() {
      // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.co.kr' : location.hostname.replace('console.', 'www')}/ToS`)
      return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.co.kr' : location.hostname.replace('console.', 'www.')}/ToS`
    },
    fields() { return _i18n_data.i18n_fields[this.i18n] },
  },
  data: () => ({
    VclFacebook,
    items: [],
    // items : [],
    version : { wsfinder : '', webcastle : '' },
    supported_modal : false,
    copy : {
      wsf_ps1 : 'Copy',
      wsf_linux : 'Copy',
      wc_ps1 : 'Copy',
      wc_lsws : 'Copy',
      wc_apache : 'Copy',
      wc_nginx : 'Copy',
      wc_tomcat : 'Copy',
      wc_webtob : 'Copy',
      wc_jeus : 'Copy',
    },
    lock : false,
    index : 0,
    auth,
    modal_charge_agree : false,
    loading : false,
    target_ip : '',
    target_port : '',
    target_volume : '',
    wsf_ps1 : '',
    wsf_linux : '',
    wc_ps1 : '',
    wc_apache : '',
    wc_nginx : '',
    wc_lsws : '',
    wc_tomcat : '',
    wc_webtob : '',
    wc_jeus : '',
    docker_line : '',
    base_href : location.hostname == 'localhost' ? 'https://api.f1secaas.co.kr' : `${location.protocol}//${location.hostname.replace(/^[^\\.]*\./, 'api.')}`,
    base_domain : location.hostname == 'localhost' ? 'api.f1secaas.co.kr' : `${location.hostname.replace(/^[^\\.]*\./, 'api.')}`,
    remember_username: false, m: { username: '', password: '' },
    use_token : false,
    // multiple
    down : { multiple : [], is_copy : false, msg : 'Create an installation script', os : '', cmd : '', webcastle: '', token : '' },
    target : '',
  }),
  methods: {
    agreement_check(target = '') {
      if(!target) { return this.$toastr.w(`${_i18n_data._i18n_error.agreement[this.i18n]}`) }
      this.modal_charge_agree = true
      this.target = target
    },
    export() {
      try {
        // console.log("copy", this.target)

        // wsfinder 윈도우 처리
        if(this.target == 'wsf_win') { return this.wsf_download() }

        let rs = this[this.target]
        for (let key in this.copy) { this.copy[key] = key == this.target ? 'Copied' : 'Copy' }

        // console.log("rs", rs)
        var tempElem = document.createElement('textarea');
        tempElem.value = rs;
        document.body.appendChild(tempElem);

        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);
        this.$toastr.i(`${i18n_data._i18n_info.copy[this.i18n]}`);
      } catch (e) { console.log(e); return this.$toastr.e(`${_i18n_data._i18n_error.copy_failed[this.i18n]}`); }
    },
    change_os(os) { this.down.webcastle = os == 'win' ? 'iis' : 'apache' },
    async ticket_token() {
      try {
        if(this.down.multiple.length < 1) { return this.$toastr.e(`${_i18n_data._i18n_error.multiple_length[this.i18n]}`) }
        if(!this.down.os) { return this.$toastr.e(`${_i18n_data._i18n_error.os[this.i18n]}`) }
        if(this.down.multiple.indexOf('webcastle') > -1 && !this.down.webcastle) { return this.$toastr.e(`${_i18n_data._i18n_error.multiple[this.i18n]}`) }
        if(location.hostname == 'localhost') { this.base_href = "https://api.f1secaas.co.kr" }

        let rs = await api.auth.licenseAgentInstall({ts : new Date().getTime()});

        // console.log("ticket token", this.down.token, this.use_token)
        if(this.use_token == true) {
          if(rs.error) { return this.$toastr.e(`${_i18n_data._i18n_error.token_failed[this.i18n]}`) }
          if(rs.body) { this.down.token = rs.body }

          let cmd = ``
          if (this.down.os == 'win') {
            // build windows
            cmd = `Set-Variable -Name UWSS_KEY -Value "${this.down.token}"`
            // wsfinder
            if (this.down.multiple.indexOf('wsfinder') > -1) { cmd += `; \\\n ${this.wsf_ps1}` }
            // webcastle
            if (this.down.multiple.indexOf('webcastle') > -1) { cmd += `; \\\n ${this.wc_ps1}` }
          } else {
            cmd = `export f1secaas=${this.base_href} \\\n && export UWSS_KEY=${this.down.token}`
            // linux
            // wsfinder
            if (this.down.multiple.indexOf('wsfinder') > -1) { cmd += ` \\\n && wget -qO- --no-check-certificate ${this.base_href}/downloads/wsfinder/v2/linux/x64/latest/installer.sh | bash` }
            // webcastle
            if (this.down.multiple.indexOf('webcastle') > -1) {
              cmd += this.down.webcastle == 'apache' ? ` \\\n && wget -qO- --no-check-certificate ${this.base_href}/downloads/webcastle/v2/linux/x64/latest/apache_installer.sh | bash` :
                ` \\\n && wget -qO- --no-check-certificate ${this.base_href}/downloads/webcastle/v2/linux/x64/latest/nginx_installer.sh | bash`
            }
          }
          this.down = Object.assign({}, this.down, { cmd : cmd })

          this.$copyText(this.down.cmd).then((rs) => { this.$toastr.s(`${i18n_data._i18n_info.copy[this.i18n]}`); location.hostname == 'localhost' ? console.log(rs) : ''; this.down.is_copy = true }, (e) => {
            console.log(e)
            return this.$toastr.e(`${_i18n_data._i18n_error.copy_error[this.i18n]}`)
          })
          location.hostname == 'localhost' ? console.log(this.down.cmd) : ''
        }
      } catch (e) { console.log(e); this.$toastr.e(`${_i18n_data._i18n_error.download_failed[this.i18n]}`) }
    },
    async license(){
      try{
        let rs = await api.auth.license({ts : new Date().getTime()});
        if(rs.error) { return this.$toastr.e(`${_i18n_data._i18n_error.token_failed[this.i18n]}`) }
        this.guid = rs;
        this.docker_line = `\
        # docker stack deploy --compose-file haproxy-compose.yml proxy --with-registry-auth
        version: '3.3'
          services:
          uwss_aio:
              image: harbor-stage.f1secaas.kr:4443/uwss/svc/aio
              networks:
              - secaas
              volumes:
                - certs:${this.target_volume}
              environment:
                DOMAINS: '${this.target_domain}'
                VOLUME : '${this.target_volume}'
                CERT : '${this.target_cert}'
                WSFINDER : '${this.target_wsfinder}'
                WEBCASTLE : '${this.target_webcastle}'
                F1HOST : '${this.base_href}'
                UWSS_KEY : '${this.guid}',
                mmdb : this.version.webcastle_mmdb
              logging:
                driver: json-file
                options:
                  max-file: 5
                  max-size: 10m
              deploy:
                replicas: 1
                placement:
                constraints:
                  - node.labels.aio == true`;
        console.info(this.docker_line, "WWWERWER")
      } catch(e) { console.log(e) }
    },
    wsf_download: function() { window.open(`${this.base_href}` + '/downloads/wsfinder/v2/win/x64/latest/installer.exe', '_blank') },
    async charge_agree() {
      let is_success = false
      try {
        if(this.index == 0) {
          // waf
          let rs = await api.webcastle.WebCastle_Call('agent', 'agree', { ts : new Date().getTime() });
          if(rs.is_error) { is_success = false }
        }
        if(this.index == 1) {
          // waf
          let rs = await api.wsfinder.WSFinder_Call('agent', 'agree', { ts : new Date().getTime() });
          if(rs.is_error) { is_success = false }
        } else {
          is_success = false
        }
        is_success = true

      } catch (e) { console.log(e); is_success = false }
      finally {
        if(is_success) {
          this.export()
        } else { this.$toastr.w(`${_i18n_data._i18n_error.export[this.i18n]}`) }
      }
    },
    async init() {
      try {
        this.loading = true

        // console.log(config)
        this.version.wsfinder = config.wsfinder_version;
        this.version.webcastle = config.webcastle_version;
        this.version.webcastle_mmdb = config.webcastle_version_mmdb;

        if(location.hostname == "localhost") {
          this.version.webcastle = config.version;
          this.version.webcastle_mmdb = config.webcastle_version_mmdb;
        }

        let cmd = 'Set-ExecutionPolicy Unrestricted -force \n [System.Net.ServicePointManager]::SecurityProtocol = [System.Net.SecurityProtocolType]::Tls12 \n'
        let is_dev = location.hostname.indexOf('f1secaas.net') > -1 || location.hostname.indexOf('f1secaas.co.kr') > -1 || location.hostname == "localhost" ? true : false

        // waf
        this.use_token = location.hostname == "localhost" || location.hostname == "console.f1secaas.co.kr"
        this.wc_ps1 = `${cmd} Set-Variable -Name f1domain -Value ${this.base_domain} -Scope Global | . { iwr -useb  https://$global:f1domain/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/win/x64/latest/f1waf.ps1 } | iex;`
        this.wc_apache = `export f1secaas=${this.base_href} && mkdir -p ./iwaf_install && wget -q --no-check-certificate ${this.base_href}/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/linux/x64/latest/installer.sh -O ./iwaf_install/installer.sh && bash ./iwaf_install/installer.sh apache`
        this.wc_nginx = `export f1secaas=${this.base_href} && mkdir -p ./iwaf_install && wget -q --no-check-certificate ${this.base_href}/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/linux/x64/latest/installer.sh -O ./iwaf_install/installer.sh && bash ./iwaf_install/installer.sh nginx`
        this.wc_lsws = `export f1secaas=${this.base_href} && mkdir -p ./iwaf_install && wget -q --no-check-certificate ${this.base_href}/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/linux/x64/latest/installer.sh -O ./iwaf_install/installer.sh && bash ./iwaf_install/installer.sh lsws`
        this.wc_tomcat = `export f1secaas=${this.base_href} && mkdir -p ./iwaf_install && wget -q --no-check-certificate ${this.base_href}/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/linux/x64/latest/installer.sh -O ./iwaf_install/installer.sh && bash ./iwaf_install/installer.sh tomcat`
        this.wc_webtob = `export f1secaas=${this.base_href} && mkdir -p ./iwaf_install && wget -q --no-check-certificate ${this.base_href}/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/linux/x64/latest/installer.sh -O ./iwaf_install/installer.sh && bash ./iwaf_install/installer.sh webtob`
        this.wc_jeus = `export f1secaas=${this.base_href} && mkdir -p ./iwaf_install && wget -q --no-check-certificate ${this.base_href}/downloads/webcastle/v2/${is_dev ? 'develop' : 'release'}/${this.version.webcastle}/linux/x64/latest/installer.sh -O ./iwaf_install/installer.sh && bash ./iwaf_install/installer.sh jeus`
        // this.items = []

        // wsfinder
        this.wsf_linux = `export f1secaas=${this.base_href}/ && wget -qO- --no-check-certificate ${this.base_href}/downloads/wsfinder/v2/${is_dev ? 'develop' : 'release'}/${this.version.wsfinder}/linux/x64/latest/installer.sh | bash`
        this.wsf_ps1 = `${cmd} Set-Variable -Name f1domain -Value ${this.base_domain} -Scope Global | . { iwr -useb  https://$global:f1domain/downloads/wsfinder/v2/${is_dev ? 'develop' : 'release'}/${this.version.wsfinder}/win/x64/latest/installer.ps1 } | iex;`

        // try {
        //   let wsfinder = await api.wsfinder.WSFinderLatest(is_dev ? 'develop' : 'release')
        //   this.version.wsfinder = wsfinder.body
        // } catch (e) { console.log(e)}

        // try {
        //   let webcastle = await api.webcastle.WebCastleLatest(is_dev ? 'develop' : 'release')
        //   this.version.webcastle = webcastle.body
        // } catch (e) { console.log(e)}

        // get webcastle mmdb version

        // try {
        //   let webcastle_mmdb = await api.webcastle.WebCastleDBLatest(is_dev ? 'develop' : 'release')
        //   this.version = Object.assign({}, this.version, { webcastle_mmdb : webcastle_mmdb.body ? webcastle_mmdb.body : '' })
        // } catch (e) { console.log(e)}


        this.items.push({
          name : 'IIS',
          os : 'Windows',
          version : this.version.webcastle,
          cmd : this.wc_ps1,
          img : 'img/logos/was_iis.png',
          key : 'wc_ps1',
          mmdb : this.version.webcastle_mmdb

        })
        this.items.push({
          name : 'Apache',
          os : 'Linux',
          version : this.version.webcastle,
          cmd : this.wc_apache,
          img : 'img/logos/was_apache.png',
          key : 'wc_apache',
          mmdb : this.version.webcastle_mmdb

        })
        this.items.push({
          name : 'nginx',
          os : 'Linux',
          version : this.version.webcastle,
          cmd : this.wc_nginx,
          img : 'img/logos/was_nginx.png',
          key : 'wc_nginx',
          mmdb : this.version.webcastle_mmdb

        })
        this.items.push({
          name : 'OpenLiteSpeed',
          os : 'Linux',
          version : this.version.webcastle,
          cmd : this.wc_lsws,
          img : 'img/logos/was_lsws.png',
          key : 'wc_lsws',
          mmdb : this.version.webcastle_mmdb

        })
        this.items.push({
          name : 'Tomcat',
          os : 'Linux',
          version : this.version.webcastle,
          cmd : this.wc_tomcat,
          img : 'img/logos/was_tomcat.png',
          key : 'wc_tomcat',
          mmdb : this.version.webcastle_mmdb

        })
        this.items.push({
          name : 'WebToB',
          os : 'Linux',
          version : this.version.webcastle,
          cmd : this.wc_webtob,
          img : 'img/logos/was_webtob.png',
          key : 'wc_webtob',
          mmdb : this.version.webcastle_mmdb

        })
        this.items.push({
          name : 'JEUS',
          os : 'Linux',
          version : this.version.webcastle,
          cmd : this.wc_jeus,
          img : 'img/logos/was_jeus.png',
          key : 'wc_jeus',
          mmdb : this.version.webcastle_mmdb
        })
      } catch (e) { console.log(e)}

      this.loading = false

    },
    toggleDetails(row) {
      if(row._showDetails){
        this.$set(row, '_showDetails', false)
      }else{
        this.currentItems.forEach(item => {
          this.$set(item, '_showDetails', false)
        })

        this.$nextTick(() => {
          this.$set(row, '_showDetails', true)
        })
      }
    }
  },
  created() { console.log('[vue] download', 'created'); },
  destroyed() { console.log('[vue] download', 'destroyed'); },
  mounted() { console.log('[vue] download', 'mounted');
    this.init()
  }
}
